export * from './linked-accounts-owned-table.component';
